import {PercentageFareDiscount} from "./percentage-fare-discount";
import {ServiceChargeTypeDotRezApiEnum} from "../../../dot-rez-api/data-contracts/enums/service-charge-type.enum";

export class PromoFareDiscount extends PercentageFareDiscount {
    getExpectedServiceCharge(): ServiceChargeTypeDotRezApiEnum {
        return ServiceChargeTypeDotRezApiEnum.PromotionDiscount;
    }
}
